import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DraggableContainer',
  props: {
    background: {},
    startPosition: {}
  },
  emits: ["newPosition"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "7fd91571": (backgroundProp.value)
}))

const emits = __emit

const props = __props
const draggableContainer = ref()
const positions = ref({
  clientX: 0,
  clientY: 0,
  movementX: 0,
  movementY: 0
})

const backgroundProp = computed<string>(() => props.background ?? 'white')
const startPosition = computed<{ left: string; top: string } | undefined>(() => props.startPosition)

function closeDragElement() {
  emits('newPosition', {
    left: draggableContainer.value.style.left,
    top: draggableContainer.value.style.top
  })
  document.onmouseup = null
  document.onmousemove = null
}
function dragMouseDown(event) {
  event.preventDefault()
  event.stopPropagation()
  // get the mouse cursor position at startup:
  positions.value.clientX = event.clientX
  positions.value.clientY = event.clientY
  document.onmousemove = elementDrag
  document.onmouseup = closeDragElement
}
function elementDrag(event) {
  event.preventDefault()
  const containerWidth = draggableContainer.value.clientWidth
  const containerHeight = draggableContainer.value.clientHeight
  const edgePadding = 8
  const maxX = window.innerWidth - containerWidth - edgePadding
  const maxY = window.innerHeight - containerHeight - edgePadding
  positions.value.movementX = positions.value.clientX - event.clientX
  positions.value.movementY = positions.value.clientY - event.clientY
  positions.value.clientX = event.clientX
  positions.value.clientY = event.clientY
  const newLeft = draggableContainer.value.offsetLeft - positions.value.movementX
  const newTop = draggableContainer.value.offsetTop - positions.value.movementY
  if (newLeft > edgePadding && newLeft <= maxX) draggableContainer.value.style.left = newLeft + 'px'
  if (newTop > edgePadding && newTop <= maxY) draggableContainer.value.style.top = newTop + 'px'
}
watch(startPosition, (newValue) => {
  if (newValue) {
    draggableContainer.value.style.left = newValue.left
    draggableContainer.value.style.top = newValue.top
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "draggable-container",
    ref_key: "draggableContainer",
    ref: draggableContainer
  }, [
    _createElementVNode("div", {
      id: "draggable-header",
      onMousedown: dragMouseDown
    }, [
      _renderSlot(_ctx.$slots, "header")
    ], 32),
    _renderSlot(_ctx.$slots, "content")
  ], 512))
}
}

})